import React from 'react';
import { createSemanticColors } from '@this/shared/ui/theme/tokens/semantic-tokens';
import type User from '@this/domain/user/user';
import { Link } from '@this/shared/ui/navigations/link';

type Props = {
  user: User;
};

const colors = createSemanticColors(1);

const styles: Record<string, React.CSSProperties> = {
  wrapper: {
    background: colors.common.white,
    textAlign: 'center',
    paddingTop: 20,
    paddingBottom: 20,
    borderRadius: '0 0 12px 12px'
  },
  small: {
    fontSize: 10,
    fontWeight: 'bold',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    padding: '0 20px'
  },
  userName: {
    fontSize: 20,
    marginTop: 7,
    marginBottom: 7,
    fontWeight: 'bold',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    padding: '0 20px'
  },
  linkArea: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 11,
    marginTop: 15
  },
  signOut: {
    margin: '0 auto'
  }
};

export const TabiregiProfilePopover: React.FC<Props> = ({ user }) => {
  return (
    <div style={styles.wrapper} data-testid="tabiregi-profile-popover">
      {user.departmentName() && <div style={styles.small}>{user.departmentName()}</div>}
      <div style={styles.userName}>{user.name}</div>
      <div style={styles.small}>{user.email}</div>
      <div style={styles.linkArea}>
        <Link href="/users/sign_out" style={styles.signOut}>
          ログアウト
        </Link>
      </div>
    </div>
  );
};
